import styled from 'styled-components'
import { themeGet } from 'styled-system'
import ReactMarkdown from 'react-markdown'
import { Accordion } from 'secondstep-components'

// Reuse the existing accordion styling pattern from StudentActivitiesCard
export const StyledAccordion = styled(Accordion).attrs({
  panelColor: themeGet('colors.hsSecondaryLightGreen'),
})`
  margin-top: 1rem;
  button[class*='AccordionPanel'] {
    background-color: ${themeGet('colors.hsSecondaryLightGreen')};
    padding-bottom: 0;
    padding-left: 1.25rem;
    padding-top: 1rem;
  }

  [class*='AccordionTitleWrapper'] {
    // put the caret on the right side of the title:
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
  }

  [class*='AccordionContent'] {
    border: none;
    padding: 0.175rem 0.625rem 0;
    background-color: ${themeGet('colors.hsSecondaryLightGreen')};
  }

  [class*='StyledCaret'] {
    margin-top: -0.5rem;
    margin-right: -1.5rem;
    color: ${themeGet('colors.hsSecondaryGreen')};
  }
  :hover {
    [class*='StyledCaret'] {
      color: ${themeGet('colors.highschool.pink1')};
    }
  }
`

// Match the exact structure of StudentActivitiesTitle
export const CollectionCardTitle = styled.h4`
  font-family: ${themeGet('fonts.moldeMedium18.fontFamily')};
  font-size: ${themeGet('fonts.moldeMedium18.fontSize')};
  line-height: 1.25rem;
  margin: 0;
  margin-bottom: 0.375rem;
  cursor: pointer;
`

// Match the CompleteIconWrapper from StudentActivitiesCard
export const IconWrapper = styled.div`
  display: inline-block;
  img {
    margin-bottom: -0.35rem;
  }
`

// Icon wrapper for non-accordion cards (without negative margin)
export const IconWrapperForCard = styled.div`
  display: inline-block;
  display: flex;
  align-items: center;
`

// Non-accordion card styling (reused from flag.off version)
export const CollectionCard = styled.div`
  cursor: pointer;
  background-color: ${themeGet('colors.hsSecondaryLightGreen')};
  // need to set height so h4 child can center vertically:
  height: auto;
  min-height: 3rem;
  border-radius: 0.625rem;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  // FIX these after redlines are available:
  padding: 1rem 1.188rem;
  margin: 1rem 0rem;
  :hover {
    border: 0.125rem solid ${themeGet('colors.highschool.green1')};
    h4 {
      margin-left: -0.125rem;
    }
  }
  h4 {
    margin: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    font-family: ${themeGet('fonts.moldeMedium18.fontFamily')};
    font-size: ${themeGet('fonts.moldeMedium18.fontSize')};
    // a little different than fonts.moldeMedium18.lineHeight:
    line-height: 1.25rem;
    color: ${themeGet('colors.hsSecondaryDarkGreen')};
  }
`

export const CollectionCardTitleWithIcon = styled.h4`
  margin: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  font-family: ${themeGet('fonts.moldeMedium18.fontFamily')};
  font-size: ${themeGet('fonts.moldeMedium18.fontSize')};
  line-height: 1.25rem;
  color: ${themeGet('colors.hsSecondaryDarkGreen')};
  gap: 0.5rem;
`

// Styled component for description with markdown support
export const DescriptionText = styled(ReactMarkdown)``

// Styled component for resource listings
export const ResourceListing = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;

  h4 {
    margin-bottom: 0.75rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: ${themeGet('colors.hsSecondaryDarkGreen')};
  }
`

// Styled component for individual resource items
export const ResourceItem = styled.button`
  height: 2.688rem;
  border: 2px solid ${themeGet('staticCollectionCard.resourceItem.border')};
  border-radius: 0.313rem;
  background-color: #f9f9f9;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;

  &:hover {
    border-color: ${themeGet('staticCollectionCard.resourceItem.borderHover')};
    div {
      color: ${themeGet('staticCollectionCard.resourceItem.borderHover')};
    }
  }

  &:focus {
    outline: 2px solid ${themeGet('colors.hsSecondaryGreen')};
    outline-offset: 2px;
  }
`

// Styled component for resource title
export const ResourceTitle = styled.div`
  font-family: ${themeGet('fontFamilySemibold')};
  color: ${themeGet('staticCollectionCard.resourceItem.border')};
  padding: 0 1rem;
`

// Styled component for resource route
export const ResourceRoute = styled.div`
  font-size: 0.75rem;
  color: #666;
`
